export default __webpack_public_path__ + "static/media/strategy1.a10263f4.png";